module.exports = __webpack_public_path__ + "static/media/snapshift-3.f039d2fc.png";